import $ from 'jquery';
import { customNumberFormat } from './utility';

$('.js-type-ids').on('click', function () {
  const postId = document.getElementById('js-post-id').value;
  const langCode = document.getElementById('js-lang-code').value;

  const listTypeGroup = document.getElementsByClassName('js-type-group-ids');
  const listType = document.getElementsByClassName('js-type-ids');

  const result = [];
  const tempGroupIds = [];
  for (let i = 0; i < listTypeGroup.length; i++) {
    tempGroupIds.push(listTypeGroup[i]?.value);
    for (let index = 0; index < listType.length; index++) {
      if (
        listType[index].tagName === 'INPUT' &&
        listType[index].checked &&
        listType[index]?.name == listTypeGroup[i]?.value
      ) {
        result.push({
          groupId: listTypeGroup[i]?.value,
          typeId: listType[index]?.value,
        });
      }
    }
  }

  if (result && result?.length != 0) {
    $.ajax({
      type: 'POST',
      url: APP_URL + '/api/product/price',
      dataType: 'json',
      data: {
        postId: postId,
        langCode: langCode,
        groupIds: tempGroupIds,
        typeGroups: result,
      },
      success: function (resposive) {
        const res = JSON.parse(resposive);
        if (res && res?.data) {
          const numberFormat = customNumberFormat(res?.data?.price);
          document.getElementById('js-price').value = res?.data?.price;
          document.getElementById('js-price-view').innerHTML = numberFormat;
        }
      },
    });
  }
});
